import { render, staticRenderFns } from "./PageEleven.vue?vue&type=template&id=70fefefa&scoped=true"
import script from "./PageEleven.vue?vue&type=script&lang=js"
export * from "./PageEleven.vue?vue&type=script&lang=js"
import style0 from "./PageEleven.vue?vue&type=style&index=0&id=70fefefa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fefefa",
  null
  
)

export default component.exports